export const isIncludeUrlComponent = (text: string): boolean => {
  if (text.includes('https') || text.includes('.com')) {
    return true;
  } else {
    return false;
  }
};
